import { widgetManager } from '../src/widgetManager/index.js'
import templates from '/app/templates'

export default class CallPopover {
  constructor({ texts, agentAvatar, handleCallWindow }) {
    this.agentAvatar = agentAvatar
    this.handleCallWindow = handleCallWindow

    const keysWithDefaults = {
      videoCallWithConsultant: 'You are now in a video call with a consultant',
      audioCallWithConsultant: 'You are now in an audio call with a consultant',
      openVideoWindow: 'Open Video Window',
      openAudioWindow: 'Open Audio Window',
      activeVideoCall: 'You have an active Video Call',
      activeAudioCall: 'You have an active Audio Call',
    }

    this.texts = {}

    Object.keys(keysWithDefaults).forEach((key) => {
      const textEntry = texts.find((t) => t.type === 'general' && t.key === key)
      this.texts[key] = textEntry ? textEntry.value : keysWithDefaults[key]
    })

    this.styleNamespace = 'cce-widget__call__popover'
    this.$element = document.createElement('div')
    this.$element.className = this.styleNamespace
    this.opened = false
  }

  open() {
    this.toggleState('open', true)
  }

  close() {
    this.toggleState('open', false)
  }

  render() {
    this.$element.innerHTML = templates.callPopover(this.getTemplateVariables())
    this.observeEvents()
  }

  getTemplateVariables() {
    return {
      agentAvatar: this.agentAvatar,
      texts: this.texts,
    }
  }

  toggleState(state, force = false) {
    this.$element.classList.toggle(`${this.styleNamespace}--${state}`, force)
    this.opened = force
  }

  observeEvents() {
    const openMinimizedWidget = document.querySelector(`.cce-widget__call__popover__container__texts-2`)
    openMinimizedWidget.addEventListener('click', () => {
      widgetManager.openWidget()
      const callPopover = document.querySelector('.cce-widget__call__popover')

      if (callPopover) {
        callPopover.classList.remove('open')
      }
    })
  }
}
